import { teacherProfileAtom } from '@openeducation/oe-it-jotai-atoms';
import { useEnvironmentContext } from '@openeducation/oe-it-providers';
import type { AxiosError } from 'axios';
import { useAtomValue } from 'jotai';
import { useQuery, useQueryClient } from 'react-query';

import { ActiveClass } from '../interfaces/active-class';
import { QueryKeys } from '../interfaces/query-keys';
import { ActiveClasses } from '../services/active-classes.service';

const ONE_MINUTE_DELAY_MS = 60000;

export function useRejoinClasses() {
  const { environment } = useEnvironmentContext();
  const queryClient = useQueryClient();

  const teacherProfile = useAtomValue(teacherProfileAtom);
  const teacherId = teacherProfile?.id;
  const {
    data: rejoinClasses,
    isLoading: isLoadingRejoinClasses,
    error: rejoinClassesError,
  } = useQuery<ActiveClass[], AxiosError>(
    [QueryKeys.RejoinClasses, teacherId],
    () => ActiveClasses.getRejoinClasses(environment, teacherId),
    {
      enabled: !!teacherId,
      refetchInterval: ONE_MINUTE_DELAY_MS,
    }
  );

  const reset = () => {
    queryClient.invalidateQueries([QueryKeys.RejoinClasses, teacherId]);
  };
  return {
    isLoadingRejoinClasses,
    rejoinClasses,
    rejoinClassesError,
    reset,
  };
}
